import { Drawer } from "@mui/material";
import { Box } from "@mui/system";

export function MobileDrawer({
  content,
  actions,
  setOpen,
  setLoading,
  open,
}: {
  open: boolean;
  content: React.ReactNode;
  actions?: React.ReactNode;
  setOpen?: (open: boolean) => void;
  setLoading?: (open: boolean) => void;
  loading?: boolean;
}) {
  return (
    <Drawer
      anchor={'bottom'}
      open={open}
      onClose={() => {
        if (setOpen) {
          setOpen(false);
          setLoading && setLoading(false);
        }
      }}
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: { display: 'none' },
        zIndex: 99999,
      })}
      transitionDuration={500}
      elevation={2}
      PaperProps={{ sx: { borderRadius: '16px 16px 0 0 ' } }}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
        p={2}
      >
        <Box height={'70%'}>{content}</Box>
        {actions && (
          <Box
            height={'30%'}
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'flex-end'}
            mt={5}
            mb={1}
            gap={2}
          >
            {actions}
          </Box>
        )}
      </Box>
    </Drawer>
  );
}